import { render, staticRenderFns } from "./observe-config.vue?vue&type=template&id=5fcb675e&scoped=true"
import script from "./observe-config.vue?vue&type=script&lang=js"
export * from "./observe-config.vue?vue&type=script&lang=js"
import style0 from "./observe-config.vue?vue&type=style&index=0&id=5fcb675e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb675e",
  null
  
)

export default component.exports